<template>
  <div class="cart-wrap">
    <div class="row">
      <div class="col-12">
        <h1>Krepšelis</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-if="basket.lines.length" class="cart-wrap-col">
          <div class="cart-wrap-col-inner">
            <div class="basket-lines basket-lines-header">
              <div class="line-col line-name">Paslauga</div>
              <!--              <div class="line-col line-qty">
                Kiekis
              </div>-->
              <!--              <div class="line-col line-price">
                Vnt. kaina
              </div>-->
              <div class="line-col line-total">Kaina</div>
              <div class="line-col line-action">Veiksmai</div>
            </div>
            <div
              v-for="(line, i) in basket.lines"
              :key="i"
              class="basket-lines"
            >
              <div class="line-col line-name">
                <span class="text-strong">{{ line.name }}</span>
              </div>
              <!--              <div class="line-col line-qty">
                <div class="res_only_basket">Kiekis:</div>
                <div class="res_only_value">{{ line.quantity }}</div>
              </div>-->
              <!--              <div class="line-col line-price">
                <div class="res_only_basket">Vnt. kaina:</div>
                <div class="res_only_value">{{ line.price / 100 }} €</div>
              </div>-->
              <div class="line-col line-total">
                <div class="res_only_basket">Kaina:</div>
                <div class="res_only_value">{{ line.line_total / 100 }} €</div>
              </div>
              <div class="line-col line-action">
                <span class="remove-action" @click="removeItem(line)">
                  <div class="res_only_basket">Veiksmai:</div>
                  <div class="res_only_value">
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="total-sum">
            <span class="total-label">Viso:</span>
            <span class="total-value">{{ total / 100 }}</span> €
          </div>
        </div>
      </div>
    </div>
    <div v-if="basket.lines.length" class="row">
      <div class="col-12">
        <div class="cart-checkout-btn-holder">
          <a href="/account/checkout">Į atsiskaitymą</a>
        </div>
      </div>
    </div>
    <div v-if="!basket.lines.length" class="row">
      <div class="col-12">
        <div class="cart-empty">Jūsų krepšelis tuščias</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cart',
  data: function () {
    return {
      grandTotal: 0,
    }
  },
  computed: {
    total() {
      return this.$store.getters['basket/basketTotal']
    },
    basket() {
      return this.$store.state.basket
    },
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '')
    },
    removeItem(line) {
      return this.$store.dispatch('basket/removeFromBasket', line)
    },
  },
}
</script>
